import { AuthToken } from '@nice-devone/common-sdk';

export function buildAuthToken(accessToken: string): AuthToken {
  const authToken = new AuthToken();
  authToken.parseData({
    access_token: accessToken,
    token_type: 'Bearer',
    expires_in: 3600,
    refresh_token: '',
    issued_token_type: '',
    id_token: '',
  });
  return authToken;
}
